/* repX quick add — cart button + size picker on product tiles.
   The actual add to cart is done by Horizon's <product-form-component>,
   so the cart count and cart drawer update the same way as everywhere else. */
(function () {
  if (window.customElements.get('repx-quick-add')) return;

  var CART_UPDATE = 'shopify:cart:lines-update';
  var openSet = new Set();

  function closeOthers(except) {
    openSet.forEach(function (q) { if (q !== except) q.close(false); });
  }

  document.addEventListener('click', function (e) {
    openSet.forEach(function (q) { if (!q.contains(e.target)) q.close(false); });
  });

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    var isOpen = typeof drawer.isOpen === 'function' ? drawer.isOpen() : drawer.isOpen;
    if (!isOpen) drawer.open();
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class RepxQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('keydown', this._onKey.bind(this));
      this.addEventListener('submit', this._onSubmit.bind(this));
      this.addEventListener(CART_UPDATE, this._onCart.bind(this));
    }

    disconnectedCallback() { openSet.delete(this); }

    get trigger() { return this.querySelector('[data-rxq-trigger]'); }
    get panel() { return this.querySelector('.rxq__panel'); }
    get form() { return this.querySelector('form'); }
    get isOpen() { return this.classList.contains('is-open'); }

    _host() { return this.closest('.rxt, product-card'); }

    _onClick(e) {
      var opt = e.target.closest('.rxq__opt');
      if (opt) {
        e.preventDefault();
        if (!opt.disabled && !this.classList.contains('is-busy')) this._choose(opt);
        return;
      }
      if (e.target.closest('[data-rxq-close]')) {
        e.preventDefault();
        this.close(true);
        return;
      }
      if (e.target.closest('[data-rxq-trigger]') && this.dataset.mode === 'pick') {
        e.preventDefault();
        if (this.isOpen) this.close(true);
        else this.open();
      }
    }

    _onKey(e) {
      if (e.key === 'Escape' && this.isOpen) {
        e.stopPropagation();
        this.close(true);
      }
    }

    open() {
      var panel = this.panel;
      if (!panel) return;
      closeOthers(this);
      this._setMsg('');
      panel.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('is-open'); });
      this.trigger.setAttribute('aria-expanded', 'true');
      openSet.add(this);
      var host = this._host();
      if (host) host.classList.add('rxq-open');
      var first = panel.querySelector('.rxq__opt:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    }

    close(returnFocus) {
      var panel = this.panel;
      if (!panel || panel.hidden) return;
      this.classList.remove('is-open');
      panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      openSet.delete(this);
      var host = this._host();
      if (host) host.classList.remove('rxq-open');
      if (returnFocus) this.trigger.focus({ preventScroll: true });
    }

    _choose(opt) {
      var form = this.form;
      var input = form && form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = opt.getAttribute('data-variant-id');
      this._chosen = opt;
      opt.classList.add('is-busy');
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    _onSubmit() {
      this.classList.add('is-busy');
      this._setMsg('');
      clearTimeout(this._timer);
      var self = this;
      // Safety net: never leave the button spinning.
      this._timer = setTimeout(function () { self._finish(null); }, 8000);
    }

    _onCart(e) {
      var self = this;
      var p = e && e.promise;
      if (p && typeof p.then === 'function') {
        p.then(function (r) { self._finish(!(r && r.detail && r.detail.didError)); })
          .catch(function () { self._finish(false); });
      } else {
        setTimeout(function () { self._finish(true); }, 700);
      }
    }

    _finish(ok) {
      clearTimeout(this._timer);
      this.classList.remove('is-busy');
      if (this._chosen) this._chosen.classList.remove('is-busy');
      if (ok === null) return;
      var self = this;
      if (ok) {
        this.close(false);
        this.classList.add('is-added');
        setTimeout(function () { self.classList.remove('is-added'); }, 1800);
        openCartDrawer();
      } else {
        this.classList.add('is-error');
        setTimeout(function () { self.classList.remove('is-error'); }, 2000);
        this._setMsg('Could not add this size. Please try another.');
      }
    }

    _setMsg(text) {
      var msg = this.querySelector('[data-rxq-msg]');
      if (msg) msg.textContent = text;
    }

    /* Rebuild for another product (used by the randomised "You may also like").
       data: { pid, t, options: [{ name, values }], variants: [{ id, available, options: [] }] } */
    setProduct(data) {
      if (!data || !data.variants || !data.variants.length) return;
      this.close(false);
      var pfc = this.querySelector('product-form-component');
      if (pfc && data.pid) pfc.setAttribute('data-product-id', data.pid);
      var input = this.querySelector('input[name="id"]');
      var firstAvail = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
      if (input) input.value = firstAvail.id;
      if (this.trigger && data.t) this.trigger.setAttribute('aria-label', 'Add ' + data.t + ' to cart');

      var varyingIdx = [];
      (data.options || []).forEach(function (o, i) { if ((o.values || []).length > 1) varyingIdx.push(i); });
      var direct = data.variants.length === 1 || varyingIdx.length === 0;
      this.dataset.mode = direct ? 'direct' : 'pick';
      var trig = this.trigger;
      if (trig) {
        trig.type = direct ? 'submit' : 'button';
        if (direct) {
          trig.removeAttribute('aria-haspopup');
          trig.removeAttribute('aria-expanded');
        } else {
          trig.setAttribute('aria-haspopup', 'true');
          trig.setAttribute('aria-expanded', 'false');
        }
      }
      if (direct) return;
      var panel = this.panel || this._buildPanel();
      var one = varyingIdx.length === 1;
      var label = one ? 'Select ' + String(data.options[varyingIdx[0]].name || '').trim() : 'Select option';
      var labelEl = this.querySelector('[data-rxq-label]');
      if (labelEl) labelEl.textContent = label;
      panel.setAttribute('aria-label', label);
      var html = data.variants.map(function (v) {
        var text = one ? v.options[varyingIdx[0]] : v.options.filter(function (x) { return x; }).join(' / ');
        return '<button type="button" class="rxq__opt" data-variant-id="' + escapeHtml(v.id) + '"' +
          (v.available ? '' : ' disabled aria-disabled="true" title="Sold out"') + '>' + escapeHtml(text) + '</button>';
      }).join('');
      var opts = this.querySelector('[data-rxq-opts]');
      if (opts) opts.innerHTML = html;
    }

    _buildPanel() {
      var panel = document.createElement('div');
      panel.className = 'rxq__panel';
      panel.setAttribute('role', 'group');
      panel.hidden = true;
      panel.innerHTML = '<div class="rxq__head"><span class="rxq__label" data-rxq-label></span>' +
        '<button type="button" class="rxq__close" data-rxq-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>' +
        '<div class="rxq__opts" data-rxq-opts></div><p class="rxq__msg" data-rxq-msg role="status" aria-live="polite"></p>';
      (this.form || this).appendChild(panel);
      return panel;
    }
  }

  window.customElements.define('repx-quick-add', RepxQuickAdd);
})();
